import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ScrollDispatcher, CdkScrollable } from '@angular/cdk/scrolling';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription, map } from 'rxjs';
import { OwlOptions, CarouselModule } from 'ngx-owl-carousel-o';
import { ThemeService, UserService } from '@wm-libs/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatCardModule } from '@angular/material/card';
import { NgClass, NgFor, NgIf, AsyncPipe, UpperCasePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { NavigationExtras, Router, RouterLink } from '@angular/router';
import { Environment } from '@wm-libs/core';
import { environment } from '../../../../../environments/environment';
import { PartnersComponent } from '../../components/partners/partners.component';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.animation.scss', './landing-page.component.scss'],
  standalone: true,
  imports: [CdkScrollable, NgClass, MatCardModule, NgFor, NgIf, CarouselModule, AsyncPipe, TranslateModule, MatButtonModule, RouterLink, UpperCasePipe, PartnersComponent],
})
export class LandingPageComponent implements OnInit, OnDestroy {
  isMobile$ = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((result) => result.matches));

  public scrollDown = false;
  public scrollSize = 90;
  private scrollSubscription!: Subscription;
  isAuth!: boolean;
  env: Environment = environment;

  isDarkMode$: Observable<boolean>;
  authSubscription!: Subscription;

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    autoplay: true,
    autoplaySpeed: 300,
    responsive: {
      0: {
        items: 2,
      },
      400: {
        items: 3,
      },
      740: {
        items: 5,
      },
      940: {
        items: 6,
      },
    },
  };

  initLoaded = false;

  advantages_mms = [
    {
      id: 1,
      title: 'WM_TECH.LANDING.ADV_MMS.TITLE1',
      text: 'WM_TECH.LANDING.ADV_MMS.TEXT1',
      alt: 'icon 1',
    },
    {
      id: 2,
      title: 'WM_TECH.LANDING.ADV_MMS.TITLE2',
      text: 'WM_TECH.LANDING.ADV_MMS.TEXT2',
      alt: 'icon 2',
    },
    {
      id: 3,
      title: 'WM_TECH.LANDING.ADV_MMS.TITLE3',
      text: 'WM_TECH.LANDING.ADV_MMS.TEXT3',
      alt: 'icon 3',
    },
  ];

  advantages_pool = [
    {
      id: 1,
      title: 'WM_TECH.LANDING.ADV_POOL.TITLE1',
      text: 'WM_TECH.LANDING.ADV_POOL.TEXT1',
      alt: 'icon 1',
    },
    {
      id: 2,
      title: 'WM_TECH.LANDING.ADV_POOL.TITLE2',
      text: 'WM_TECH.LANDING.ADV_POOL.TEXT2',
      alt: 'icon 2',
    },
    {
      id: 3,
      title: 'WM_TECH.LANDING.ADV_POOL.TITLE3',
      text: 'WM_TECH.LANDING.ADV_POOL.TEXT3',
      alt: 'icon 3',
    },
  ];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private scrollDispatcher: ScrollDispatcher,
    private cdr: ChangeDetectorRef,
    private themeService: ThemeService,
    private userService: UserService,
    private router: Router
  ) {
    this.isDarkMode$ = this.themeService.isDarkMode$;

    this.authSubscription = this.userService.isAuthenticated$.subscribe((status) => {
      this.isAuth = status;
    });
  }

  ngOnInit(): void {
    this.scrollSubscription = this.scrollDispatcher.scrolled().subscribe((scrollable) => {
      if (scrollable) {
        this.scrollDown = scrollable.measureScrollOffset('top') > this.scrollSize;

        this.cdr.detectChanges();
      }
    });

    setTimeout(() => {
      this.initLoaded = true;
    }, 0);
  }

  redirect(domain: string) {
    const queryParams = domain === 'mms' ? { redirectToMms: true } : { redirectToPool: true };

    const navigationExtras: NavigationExtras = {
      queryParams,
      replaceUrl: true,
    };

    if (this.isAuth) {
      window.location.href = domain === 'mms' ? this.env.techMmsDomain : this.env.techPoolDomain;
    } else {
      this.router.navigate(['/auth/sign-in'], navigationExtras);
    }
  }
  ngOnDestroy() {
    this.scrollSubscription?.unsubscribe();
    this.authSubscription?.unsubscribe();
  }
}
